import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVertexRemove = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1 1L11.15 3.45L12.2 8.7L8.7 12.2L3.45 11.15L1 1ZM1 1L6.3102 6.3102M8 12.9L12.9 8L15 10.1L10.1 15L8 12.9ZM8.7 7.3C8.7 8.0732 8.0732 8.7 7.3 8.7C6.5268 8.7 5.9 8.0732 5.9 7.3C5.9 6.5268 6.5268 5.9 7.3 5.9C8.0732 5.9 8.7 6.5268 8.7 7.3Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_6547_624)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.0833 0.083313H16.9166V0.916646H11.0833V0.083313Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6547_624",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 6,
				height: 1,
				fill: "white",
				transform: "translate(11)"
			})
		}) })
	]
});
export default SvgVertexRemove;
